import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

const DocumentsDialogDelete = (props) => (
	<Dialog
		onClose={props.handleClose}
		aria-labelledby="document-dialog-delete-title"
		aria-describedby="document-dialog-delete-description"
		open={props.open}
		fullWidth
		maxWidth="xs"
	>
		<DialogTitle id="document-dialog-delete-title">
			<Translate id="documents.dialogs.delete.title" />
		</DialogTitle>
		<DialogContent>
			<DialogContentText id="document-dialog-delete-description">
				<Typography>
					<Translate id="documents.dialogs.delete.text" />
				</Typography>
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={props.handleClose} color="default" autoFocus>
				<Translate id="documents.dialogs.close" />
			</Button>
			<Button onClick={props.submit} color="primary">
				<Translate id="documents.dialogs.delete.submit" />
			</Button>
		</DialogActions>
	</Dialog>
);

export default withLocalize(DocumentsDialogDelete);
